import { render } from "./InformeHornos.vue?vue&type=template&id=bcacde9a&scoped=true"
import script from "./InformeHornos.vue?vue&type=script&lang=js"
export * from "./InformeHornos.vue?vue&type=script&lang=js"

import "./InformeHornos.vue?vue&type=style&index=0&id=bcacde9a&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcacde9a"]])

export default __exports__